import { render, staticRenderFns } from "./TestPackDetail.vue?vue&type=template&id=759c7aff&scoped=true"
import script from "./TestPackDetail.vue?vue&type=script&lang=js"
export * from "./TestPackDetail.vue?vue&type=script&lang=js"
import style0 from "./TestPackDetail.vue?vue&type=style&index=0&id=759c7aff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "759c7aff",
  null
  
)

export default component.exports